import PrinterConfig from './PrinterConfig.view';

export default PrinterConfig;
